import axios from 'axios'
//
// initial state
const state = {
  products: [],
  settings: {},
  status: {
    loading: false,
    error: false,
    success: false
  }
}

// actions
const actions = {
  getProducts ({ commit }, { api, params }) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[products:getProducts] start', { api, params })
    }
    commit('products/setStatus', { loading: true }, { root: true })
    commit('products/setStatus', { success: false }, { root: true })
    commit('products/setStatus', { error: false }, { root: true })

    axios.get(api, {
      params: params,
      data: null,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
      })
      .then(response => {
        const raw = response && response.data
        const data = raw && raw.Data ? raw.Data : raw
        const results = data && data.Results ? data.Results : data

        if (process.env.NODE_ENV !== 'production') {
          const count = Array.isArray(results?.Items)
            ? results.Items.length
            : Array.isArray(results)
              ? results.length
              : null
          // eslint-disable-next-line no-console
          console.log('[products:getProducts] success', { totalItems: results?.TotalItems, pageCount: results?.PageCount, items: count })
        }

        // Always pass an array to setProducts for clarity
        const items = Array.isArray(results?.Items)
          ? results.Items
          : Array.isArray(results)
            ? results
            : []
        commit('products/setProducts', items, { root: true })
        commit('products/setSettings', results, { root: true })
        commit('products/setStatus', { success: true }, { root: true })
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.error('[products:getProducts] error', error?.response?.status, error?.message)
        }
        commit('products/setStatus', { success: false }, { root: true })
        commit('products/setStatus', { error: true }, { root: true })
      })
      .finally(() => commit('products/setStatus', { loading: false }, { root: true }))
  },
}

// mutations
const mutations = {
  setSettings (state, data) {
    // Accept only object-shaped paging metadata; otherwise reset to {}
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      state.settings = {
        totalItems: data.TotalItems,
        pageCount: data.PageCount,
        pageItems: data.PageItems ?? data.PageSize
      }
    } else {
      state.settings = {}
    }
  },

  setProducts (state, data) {
    if (
      data == null ||
      (Array.isArray(data) && data.length === 0)
    ) {
      state.products = []
      return
    }

    if (Array.isArray(data)) {
      state.products = data
      return
    }

    if (Array.isArray(data.Items)) {
      state.products = data.Items
      return
    }

    state.products = []
  },

  updateProducts (state, data) {
    if (data == null) {
      state.products = []
      return
    }

    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.Items)
        ? data.Items
        : []

    state.products = [...state.products, ...items]
  },


  setStatus (state, statusObj) {
    const key = Object.keys(statusObj)[0]
    const value = Object.values(statusObj)[0]
    state.status[key] = value
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
